export const inputMaskPt = () => {
  return {
    pcInputText: {
      root: {
        inputmode: 'numeric'
      }
    }
  }
}
